const removeHTMLEntities = html => {
  let el = document.createElement("div");
  el.innerHTML = html;
  return el.childNodes.length === 0 ? "" : el.childNodes[0].nodeValue;
};

export { removeHTMLEntities };
